import _ from "lodash";

const params = {
  template: "reduced",
};

export function getOperator(operator) {
  return Vue.http
    .get(`entity/operators/${operator}`, params)
    .then((response) => response.data.data);
}

/**
 * After various tests I am unable to use this endpoints. It appears to try authentication with an operator account
 * filter options from back:
 * :administrative_area_id, :country_id, :compensation_center_id, :avl_user_id,
 * :not_in_cc_in_administrative_area_id, :avl_service_code, :line_id, :subline_id, :route_id,
 * :dispatcher_id, :line_dispatch_type, :bus_sanitization, :version, :route_and_version
 * 
 * @param {*} administrativeAreaId 
 * @returns 
 */
export function getOperatorsData(administrativeAreaId='') {
  if(_.isEmpty(administrativeAreaId)) return []
  const params = {
    administrative_area_id: administrativeAreaId
  }
  
  return Vue.http
    .get(`entity/operators`, params)
    .then((response) => response.data.data);
}
